import {
  router,
  resetRouter
} from '@/router/index'
import store from '@/store/index'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (to.meta.notrequireAuth) {
    next()
  } else {
    if (localStorage.getItem('Authorization')) {
      console.log(store.state)
      if (store.state.menuList.length === 0) {
        console.log('----------')
        resetRouter()
        store.dispatch('getAllMenu').then((res) => { // 生成可访问的路由表
          const routes = store.state.routersList
          router.options.routes = routes
          // // 动态添加可访问路由表
          router.addRoutes(routes)
          next({
            ...to,
            replace: true
          }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          // next()
        })
      } else {
        if (localStorage.getItem('store')) {
          store.replaceState(Object.assign({}, store.state, JSON.parse(localStorage.getItem('store'))))
        }
        // 在页面刷新时将vuex里的信息保存到sessionStorage里
        window.addEventListener('beforeunload', () => {
          localStorage.setItem('store', JSON.stringify(store.state))
        })
        next()
        NProgress.done()
      }
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(async (to, from) => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/router/routeInterceptor.js